import { useCallback } from 'react';

import store, { useRecoilState, useRecoilValue } from '@store';

export const useSearchPagination = () => {
  const searchPageData = useRecoilValue(store.searchPageData);
  const [selectedResultsPerPage, setSelectedResultsPerPage] = useRecoilState(
    store.searchSelectedResultsPerPage
  );
  const [currentResultsPage, setCurrentResultsPage] = useRecoilState(
    store.searchCurrentResultsPage
  );

  const { previousPage, nextPage, totalPages } =
    searchPageData?.pagination || {};

  const updateResultsPerPage = useCallback((num) => {
    if (!num) {
      return console.error(
        'updateResultsPerPage: an integer from 1-100 must be passed'
      );
    }
    setSelectedResultsPerPage(num);
  }, []);

  const goToPrevPage = useCallback(() => {
    if (!previousPage) return;
    setCurrentResultsPage(previousPage);
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [previousPage]);

  const goToNextPage = useCallback(() => {
    if (!nextPage) return;
    setCurrentResultsPage(nextPage);
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [nextPage]);

  const goToPage = useCallback(
    (num) => {
      if (!num || num > totalPages) return;
      setCurrentResultsPage(num);
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    [totalPages]
  );

  return [
    // state
    {
      resultsPerPage: selectedResultsPerPage,
      currentPage: currentResultsPage,
      totalPages: totalPages || 1,
    },
    // actions
    {
      updateResultsPerPage,
      goToPrevPage,
      goToNextPage,
      goToPage,
    },
  ];
};
